<template>
  <div class="container-fluid" style="zoom: 80%">
    <div class="row">
      <div class="col-md-12 mb-2">
        <h3 style="font-weight:700">Pengaturan Faskes</h3>
      </div>
      <!-- sidebar menu -->
      <div class="col-md-2 no-padding pr-0">
        <div
          class="card card-box"
          style="border-radius : 0%; height: 100%; min-height: 650px;"
        >
          <div class="card-body">
            <div class="col-md-12 p-0 text-center">
              <div
                class="col-md-12 p-2 text-left _outer_klinik_profile"
                @click="selectTab('location')"
              >
                <strong
                  style="font-size:12px; cursor: pointer;"
                  :class="
                    activeTab == 'location' ? '__blue text-left' : 'text-left'
                  "
                  >Lokasi</strong
                >
              </div>
              <hr style="margin-top:2px;margin-bottom:2px" />
              <div
                class="col-md-12 p-2 text-left _outer_klinik_profile"
                @click="selectTab('jasa_medis')"
              >
                <strong
                  style="font-size:12px; cursor: pointer;"
                  :class="
                    activeTab == 'jasa_medis' ? '__blue text-left' : 'text-left'
                  "
                  >Skema Komisi</strong
                >
              </div>
              <hr style="margin-top:2px;margin-bottom:2px" />
              <div
                class="col-md-12 p-2 text-left _outer_klinik_profile"
                @click="selectTab('bridging_bpjs')"
              >
                <strong
                  style="font-size:12px; cursor: pointer;"
                  :class="
                    activeTab == 'bridging_bpjs'
                      ? '__blue text-left'
                      : 'text-left'
                  "
                  >Bridging BPJS</strong
                >
              </div>
              <hr style="margin-top:2px;margin-bottom:2px" />
              <template v-if="isDokter">
                <div
                  class="col-md-12 p-2 text-left _outer_klinik_profile"
                  @click="selectTab('bridging_icare')"
                >
                  <strong
                    style="font-size:12px; cursor: pointer;"
                    :class="
                      activeTab == 'bridging_icare'
                        ? '__blue text-left'
                        : 'text-left'
                    "
                    >Bridging I - Care</strong
                  >
                </div>
                <hr style="margin-top:2px;margin-bottom:2px" />
              </template>
              <div
                class="col-md-12 p-2 text-left _outer_klinik_profile"
                @click="selectTab('bridging_satusehat')"
              >
                <strong
                  style="font-size:12px; cursor: pointer;"
                  :class="
                    activeTab == 'bridging_satusehat'
                      ? '__blue text-left'
                      : 'text-left'
                  "
                  >Integrasi Satu Sehat</strong
                >
              </div>
              <hr style="margin-top:2px;margin-bottom:2px" />
            </div>
          </div>
        </div>
      </div>
      <!-- Location -->
      <div class="col-md-10 pl-0" v-if="activeTab == 'location'">
        <LocationFaskes />
      </div>

      <!-- Jasa Medis-->
      <div class="col-md-10 pl-0" v-if="activeTab == 'jasa_medis'">
        <JasaMedisFaskes />
      </div>

      <!-- Bridging BPJS -->
      <div class="col-md-10 pl-0" v-if="activeTab == 'bridging_bpjs'">
        <BridgingBpjsFaskes />
      </div>

      <!-- Bridging satusehat -->
      <div class="col-md-10 pl-0" v-if="activeTab == 'bridging_satusehat'">
        <BridgingSatusehatFaskes />
      </div>

      <!-- Bridging I-care -->
      <div class="col-md-10 pl-0" v-if="activeTab == 'bridging_icare'">
        <BridgingIcareComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import BridgingIcareComponent from "../Dokter/BridgingIcareComponent.vue";

import {
  faInfo,
  faFolder,
  faCamera,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
library.add(faInfo, faCamera, faFolder, faTimes);

export default {
  components: {
    LocationFaskes: () => import("./LocationComponent.vue"),
    JasaMedisFaskes: () => import("./JasaMedisComponent.vue"),
    BridgingBpjsFaskes: () => import("./BridgingBpjsComponent.vue"),
    BridgingSatusehatFaskes: () => import("./BridgingSatuSehatComponent.vue"),
    BridgingIcareComponent
  },
  data() {
    return {
      activeTab: "location"
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"]),
    isPic() {
      return /pic/.test(this.getRolesName);
    },
    isDokter() {
      return /dokter/.test(this.getRolesName);
    }
  },
  watch: {},
  methods: {
    selectTab(menu) {
      this.activeTab = menu;
    }
  }
};
</script>

<style scoped>
.__blue {
  color: #4b80b6;
}
.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: -20px;
  z-index: 20;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.delete_photo {
  position: absolute;
  width: 100%;
  height: 20%;
  top: 30%;
  z-index: 9;
  font-size: 30pt;
  text-align: center;
}
.profile-custom {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  border: 1px solid #cdcdcd;
}

.profile-custom img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}
</style>
